import React, { useContext } from 'react';
import { FaBan, FaExclamationTriangle } from 'react-icons/fa';
import { AuthContext } from '../context/AuthContext';
import './AccountStatusModal.css';

const SUPPORT_URL = 'https://t.me/lunasearch';

// Friendly fallback copy when there's no admin-typed reason on file.
const BAN_DEFAULTS = {
  admin_full_ban: 'This account was banned by an administrator.',
  admin_full_ban_cascade: 'This account was banned along with others found to share the same device.',
  manual: 'This account was banned by an administrator.',
};
const SUSPEND_DEFAULTS = {
  ban_evasion: 'This account was suspended automatically because it was used from a device associated with a banned account (ban evasion).',
  manual: 'This account was suspended by an administrator.',
};

// Full-screen, non-dismissable takeover shown for banned/suspended accounts —
// rendered at the App root (inside AuthProvider) so it appears over whatever
// page is underneath, on every load, until the account is cleared or the
// user logs out. Mirrors the Discord "Your account is banned/suspended"
// pattern: reason, a working Logout, and a way to reach support.
const AccountStatusModal = () => {
  const { user, logout } = useContext(AuthContext);

  if (!user || (!user.accountBanned && !user.accountSuspended)) return null;

  const banned = user.accountBanned === true;
  const title = banned ? 'Your account is banned' : 'Your account is suspended';
  const reason = banned
    ? (user.banReasonText || BAN_DEFAULTS[user.bannedReason] || 'This account was banned by our automated anti-abuse system.')
    : (user.suspendReasonText || SUSPEND_DEFAULTS[user.suspendedReason] || 'This account was suspended by our automated anti-abuse system.');

  return (
    <div className="account-status-overlay" role="alertdialog" aria-modal="true">
      <div className="account-status-card">
        <div className={`account-status-icon ${banned ? 'account-status-icon-banned' : 'account-status-icon-suspended'}`}>
          {banned ? <FaBan size={30} /> : <FaExclamationTriangle size={30} />}
        </div>
        <h1 className="account-status-title">{title}</h1>
        <p className="account-status-reason">{reason}</p>
        <p className="account-status-help">
          If you believe this is a mistake, contact support and we'll take a look.
        </p>
        <div className="account-status-actions">
          <button
            type="button"
            className="account-status-btn account-status-btn-primary"
            onClick={() => window.open(SUPPORT_URL, '_blank', 'noopener,noreferrer')}
          >
            Contact Support
          </button>
          <button type="button" className="account-status-btn account-status-btn-secondary" onClick={logout}>
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccountStatusModal;
